import * as tf from "@typeform/embed";
import { IFormProps } from "./Form.interface";
import { ModuleContext } from "../../../shared/providers/module/module.provider";
import { useContext, useEffect, useMemo, useRef } from "react";
import { TranslationContext } from "../../../shared/providers/translation/translation.provider";
import {
    ComponentTypes,
    ExternalPlatforms
} from "../../../shared/interfaces/modules.interface";
import { AuthenticationContext } from "../../../shared/providers/authentication/authentication.provider";
import Button from "../../Button/Button";
import Link from "../../Link/Link";

function Form(props: IFormProps) {
    const { formId, sector, videoUrl } = props;
    const { user } = useContext(AuthenticationContext);
    const { lang, translate } = useContext(TranslationContext);
    const { setProgress } = useContext(ModuleContext);
    const form = useRef<HTMLDivElement>(null);
    const userSector = useMemo(() => user?.company.sector, [user]);
    const hasInitialScreen = useMemo(() => (!!props.formTitle || !!props.formDescription || !!props.videoUrl), [props]);

    const handleSubmit = (event: { formId: string; responseId: string }) => {
        if (!lang) return;

        setProgress({
            unitId: props.unitId,
            itemId: props.id,
            progress: 100,
            itemType: ComponentTypes.FORM,
            itemLocale: lang,
            externalId: event.formId,
            externalPlatform: ExternalPlatforms.TYPEFORM,
            externalData: event.responseId
        });
    };

    useEffect(() => {
        if (!form.current) return;

        tf.createWidget(formId, {
            container: form.current.querySelector("[data-tf-widget]")!,
            inlineOnMobile: true,
            onSubmit: handleSubmit,
            onQuestionChanged: (e) => console.log(e),
            onStarted: (e) => console.log(e)
        })
    }, [form])

    if ((userSector && sector?.length > 0 && !(sector.includes(userSector.id))) || !formId) return <></>

    return (<div className="typeform_wrapper">
        {hasInitialScreen &&
            <div className="typeform_entry p-3 d-flex flex-column pt-5 gap-12 align-items-start">
                {props.formTitle && <h2 className=" text-h2-bd">{props.formTitle}</h2>}
                {props.formDescription && <p className=" text-bd1-md">{props.formDescription}</p>}
                {props.videoUrl && <video src={videoUrl} className="w-100" controls></video>}
                <Button type="button" variant="solid" customCss="px-3 mt-2" onClick={() => {
                    form.current?.classList.remove("d-none")
                }}>{translate("units.start_quizz", "Start quizz")}</Button>
            </div>}
        <div
            ref={form}
            className={`typeform w-100 ${hasInitialScreen ? "d-none" : ""}`}
        >
            {hasInitialScreen && <Button
                type="button"
                onClick={() => form.current?.classList.add("d-none")}
                icon="Chevron--left"
                iconSize={20}
                label={translate("common.back", "Back")}
                customCss="typeform_back gap-02 text-bd2-rg ms-n1 mb-12"
            />}
            <div
                data-tf-widget={formId}
                id={formId}>
            </div>
        </div>
    </div>
    );
}

export default Form;
